export const orderAgeMarks = [
    {
        value: 1,
        label: '1 day',
    },
    {
        value: 2,
        label: '2 days',
    },
    {
        value: 3,
        label: '3 days',
    },
    {
        value: 4,
        label: '7 days',
    },
    {
        value: 5,
        label: '14 days',
    },
    {
        value: 6,
        label: '21 days',
    },
    {
        value: 7,
        label: '30 days',
    },
    {
        value: 8,
        label: '60 days',
    },
    {
        value: 9,
        label: 'All',
    },
]

export const driverLastSeenMarks = [
    {
        value: 1,
        label: '1day',
    },
    {
        value: 2,
        label: '2 days',
    },
    {
        value: 3,
        label: '3 days',
    },
    {
        value: 4,
        label: '7 days',
    },
    {
        value: 5,
        label: '14 days',
    },
    {
        value: 6,
        label: '21 days',
    },
    {
        value: 7,
        label: '30 days',
    },
]

export const driverVehicleTypes = [
    { color: '#000000', value: "all", label: "All" },
    { color: '#607d8b', value: "0", label: "car" },
    { color: '#607d8b', value: "1", label: "motorbike" },
    { color: '#607d8b', value: "2", label: "van" },
    { color: '#607d8b', value: "3", label: "minivan" },
    { color: '#607d8b', value: "4", label: "pickup" },
    { color: '#607d8b', value: "5", label: "small_truck" },
    { color: '#607d8b', value: "6", label: "large_truck" },
]

export const driverDeviceTypes = [
    { color: '#000000', value: "all", label: "All" },
    { color: '#607d8b', value: "android", label: "android" },
    { color: '#607d8b', value: "ios", label: "ios" },
]

export const driverUniformTypes = [
    { value: "all", label: "All" },
    { value: "0", label: "branded" },
    { value: "1", label: "unbranded" },
]

export const driverStatusTypes = [
    { color: '#000000', value: "all", label: "All" },
    { color: '#5db050', value: "free", label: "Online available" },
    { color: '#ea5034', value: "busy", label: "Online busy" },
    { color: '#607d8b', value: "offline", label: "Offline" },
]

export const shipmentHubStatuses = [
    { color: '#000000', value: "all", label: "All" },
    { color: '#5db050', value: "true", label: "Open hubs" },
    { color: '#ea5034', value: "false", label: "Closed hubs" },
]

export const shipmentPaymentMethod = [
    { color: '#030303ff', value: "all", label: "All" },
    { color: '#5db050', value: "cash_on_delivery", label: "Cash on delivery" },
    { color: '#ea5034', value: "credit_card", label: "Credit Card" },
]

export const DRIVER_LAST_SEEN_MIN_MARK = 1
export const DRIVER_LAST_SEEN_MAX_MARK = 7